<div class="row no-gutters mt-3"
     data-cy="mb-product-filters">
  <div [ngClass]="(nonPrimaryFilters$ | async)?.length ? 'col-12 col-md-6 pr-sm-4' : 'col-12'"
       *ngIf="(primaryFilter$ | async) as primaryFilter"
       data-cy="mb-product-filters-primary">
    <mb-pdp-product-filter [filterData]="primaryFilter"></mb-pdp-product-filter>
  </div>

  <div class="col-12 col-md-6"
       *ngFor="let nonPrimaryFilter of (nonPrimaryFilters$ | async); index as i"
       [attr.data-cy]="'mb-product-filters-non-primary-' + i">
    <mb-pdp-product-filter [filterData]="nonPrimaryFilter"></mb-pdp-product-filter>
  </div>
</div>
